// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"job-match-list_ellipsis__1Ar_b"};